/**
 * MatchRow component is used in different CONTEXT (Match Results, Card Calendar etc.)
 * We should pass a CONTEXT/BEHAVIOR using differert TYPES
 */
export type Source = 'results' | 'results-thick' | 'card'; // Possible TYPE NAMES: Context/Source/Type
export const RESULTS: Source = 'results';
export const CARD: Source = 'card';
export const RESULTS_THICK: Source = 'results-thick';
export const MatchRowSources: Array<Source> = [RESULTS, RESULTS_THICK, CARD];

// A HREF possible target values
export type CtaTarget = '_blank' | '_self' | '_parent' | '_top'; // FIXME: add "| string" if needed to TARGET an IFRAME NAME in the future!
export const CTA_TARGET_BLANK = '_blank';
export const CTA_TARGET_SELF = '_self';
export const CTA_TARGET_PARENT = '_parent';
export const CTA_TARGET_TOP = '_top';
export const CtaTargets: Array<CtaTarget> = [CTA_TARGET_BLANK, CTA_TARGET_PARENT, CTA_TARGET_SELF, CTA_TARGET_TOP];
